<template>
  <ContentBlock>
    <TableWithPagination class="special" :columnList="columnList" :tableData="targetLists" :toolBar="toolBar"
      :sortInfo.sync="updateSortInfo" tableBorder="default" :showRightToolbar="true" :pagination.sync="pagination"
      @size-change="handleChangePage" @current-change="handleChangePage" @sort-change="handleSortChange"
      :highHoverRow="false" :highlightRow="false" />
    <el-drawer title="高级筛选" width="500" direction="rtl" :modal-append-to-body="false" :visible.sync="isShow"
      :close-on-click-modal="false" @closed="isShow = false">
      <el-form label-width="auto" label-position="right" style="margin-top: 20px;padding: 10px;">
        <el-row>
          <el-col :span='24'>
            <el-form-item label="姓名">
              <el-input placeholder="请输入" v-model.trim="form.name" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="手机号">
              <el-input placeholder="请输入" v-model.trim="form.phoneNumber" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="银行名称">
              <el-input placeholder="请输入" v-model.trim="form.bankName" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="邀请码">
              <el-input placeholder="请输入" v-model.trim="form.inviteCode" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align: center;">
        <el-button @click="handleEmpty">清空</el-button>
        <el-button type="primary" @click="handleQuery">查询</el-button>
      </div>
    </el-drawer>
  </ContentBlock>
</template>
<script>
import TableWithPagination, { TablePaginationMixin } from '@/components/common/TableWithPagination';
import * as dayjs from 'dayjs';
import icRefresh from '@/assets/table/ic_refresh.svg';
import icAdvanceSearch from '@/assets/table/ic_advanceSearch.svg';
import { promoterList } from '@/api/distribution';

export default {
  components: {
    TableWithPagination,
  },
  mixins: [TablePaginationMixin],
  computed: {
    toolBar () {
      let currentLists = [
        {
          type: 'custom',
          render: () => {
            return (
              <el-input placeholder='请输入姓名' style='width:250px;' v-model={this.outform.name}>
                <el-button slot="suffix" icon="el-icon-search" onClick={this.handleSearch} style='position: absolute;height: 100%;right: -5px;top: 0;'>
                </el-button>
              </el-input>
            );
          },
        },
        {
          type: 'custom',
          render: () => {
            return (
              <vxe-button circle onClick={this.handleAdvancedSearch}>
                <img style='font-size:14px;width:15px;height:15px;' src={icAdvanceSearch} />
              </vxe-button>
            );
          },
        },
        {
          type: 'custom',
          render: () => {
            return (
              <vxe-button circle onClick={this.handleReset}>
                <img style='font-size:14px;width:15px;height:15px;' src={icRefresh} />
              </vxe-button>
            );
          },
        },
      ];
      return currentLists;
    },
    columnList () {
      const cols = [
        {
          tooltip: true,
          label: '推广员ID',
          minWidth: '100px',
          width: '',
          prop: 'code',
        },
        {
          tooltip: true,
          label: '姓名',
          minWidth: '100px',
          width: '',
          prop: 'name',
        },
        {
          tooltip: true,
          label: '手机号',
          minWidth: '130px',
          width: '',
          prop: 'phoneNumber',
        },
        {
          tooltip: true,
          label: '成为推广员时间',
          minWidth: '150px',
          width: '',
          prop: 'becomeTime',
          format: (v) => {
            return this.formatTime(v);
          },
        },
        {
          tooltip: true,
          label: '银行名称',
          minWidth: '150px',
          width: '',
          prop: 'bankName',
        },
        {
          tooltip: true,
          label: '银行账户',
          minWidth: '180px',
          width: '',
          prop: 'bankAccount',
        },
        {
          tooltip: true,
          label: '邀请码',
          minWidth: '100px',
          width: '',
          prop: 'inviteCode',
        },
        {
          tooltip: true,
          label: '累计邀请用户数',
          minWidth: '120px',
          width: '',
          prop: 'totalInviteUserCount',
        },
        {
          tooltip: true,
          label: '有效邀请用户数',
          minWidth: '120px',
          width: '',
          prop: 'effectiveInviteUserCount',
        },
        {
          label: '操作',
          width: '120px',
          fixed: 'right',
          render: (h, { row }) => {
            let actions = [];
            actions.push(<span
              class="table-action"
              onClick={this.handleActionClick.bind(this, row, 'detail')}>
              详情
            </span>);
            return <div>{...actions}</div>;
          },
        },
      ];
      return cols;
    },
  },
  data () {
    return {
      outform: {
        name: '',
      },
      form: {
        name: '',
        phoneNumber: '',
        bankName: '',
        inviteCode: '',
      },
      targetLists: [],
      isShow: false,
    };
  },
  methods: {
    formatTime (v) {
      let ret = '';

      if (v) {
        ret = dayjs(v * 1).format('YYYY-MM-DD HH:mm');
      }

      return ret;
    },
    handleActionClick (row, action) {
      if (action === 'detail') {
        this.$router.push({
          name: 'Distribution_Promotion_Detail',
          query: {
            promoterId: row.id,
            info: row,
          },
        });
      }
    },
    handleEmpty () {
      this.form = this.$options.data().form;
    },
    handleChangePage (page) {
      this.outform = { ...this.outform, ...page};
      this.getTargetLists();
    },
    handleQuery () {
      this.pagination.currentPage = 1;

      this.getTargetLists(this.form);

      this.$nextTick(() => {
        this.outform = { ...this.form };
        this.isShow = false;
      });
    },
    handleSearch () {
      this.pagination.currentPage = 1;

      this.getTargetLists();
    },
    handleAdvancedSearch () {
      this.form = { ...this.outform };

      this.isShow = true;
    },
    handleReset () {
      this.outform = this.$options.data().outform;

      this.pagination.currentPage = 1;

      this.getTargetLists();
    },
    handleSortChange () {
      this.pagination.currentPage = 1;

      this.getTargetLists();
    },
    getTargetLists (form = this.outform) {
      const params = {
        ...form,
        name: form.name.trim(),
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        orderBy: [this.updateSortInfo],
      };

      promoterList(params).then(({ body }) => {
        this.targetLists = body?.list || [];

        this.pagination.total = body?.total || 0;
      });
    },
  },
  created () {
    this.handleSearch();
  },
};
</script>
<style lang="scss" scoped>
/deep/.vxe-tools--wrapper {
  display: flex;
  justify-content: space-between;

  &>.el-button {
    margin-left: 0.5em;
  }

  &>div.el-input {
    margin-left: 0.5em;
  }

  &>.vxe-button {
    margin-left: 0.5em;
  }
}

/deep/ .vxe-tools--operate {
  &>.vxe-button {
    margin-left: 0.5em;
  }
}

/deep/ .action {
  color: #409EFF;
  cursor: pointer;

  &:hover {
    color: rgba(64, 158, 255, 0.7);
    text-decoration: underline;
  }
}

/deep/ .el-date-editor.el-input {
  width: -webkit-fill-available;
}
</style>
